import { withStylePrefix } from '../common/withStylePrefix';
import { GotoLogoComponent, gotoLogoTemplate } from './GotoLogo';
import styles from './GotoLogo.styles.scss';
export const gotoLogoDefinition = {
    baseName: 'goto-logo',
    template: gotoLogoTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonGotoLogo = GotoLogoComponent.compose(gotoLogoDefinition);
